import { render, staticRenderFns } from "./university.vue?vue&type=template&id=79fde067&scoped=true"
import script from "./university.vue?vue&type=script&lang=js"
export * from "./university.vue?vue&type=script&lang=js"
import style0 from "./university.vue?vue&type=style&index=0&id=79fde067&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79fde067",
  null
  
)

export default component.exports